export const COVER_BANNER_PADDING_BOTTOM = 110;
